var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.iconName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }